import { resources } from '../../utils/resources';
import './Withdraw.css';

const Withdraw = () => {
    return (
        <div class="withdrawPage">
            <div class="withdrawPage__content">
                <img class="withdrawPage__imgContent" src={resources.icons.sad_icon} />
                <span class="withdrawPage__textContent">Withdrawal will be available soon… <br /> Donald J. Trump’s liquidity is being implemented.</span>
            </div>
        </div>
    );
}

export default Withdraw;